export default __webpack_public_path__ + "962a753bd0356a5716c8b38589302d93.jpg";